import { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import {
  MenuRoot,
  MenuTrigger,
  MenuPortal,
  MenuPositioner,
  MenuPopup,
} from './menu';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
}

export function Select({
  value,
  onChange,
  options,
  placeholder = 'Selecione...',
  className,
}: SelectProps) {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <MenuRoot open={open} onOpenChange={setOpen}>
      <MenuTrigger
        render={
          <button
            type="button"
            className={twMerge(
              'flex h-9 cursor-pointer items-center gap-2 rounded-md border border-border bg-surface px-3 text-sm text-foreground transition-colors hover:bg-muted',
              className
            )}
          >
            <span>{selectedOption?.label || placeholder}</span>
            <ChevronDown className="size-4 text-muted-foreground" />
          </button>
        }
      />
      <MenuPortal>
        <MenuPositioner sideOffset={8}>
          <MenuPopup>
            {options.map((option) => {
              const isSelected = option.value === value;
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    onChange(option.value);
                    setOpen(false);
                  }}
                  className="flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-sm text-foreground transition-colors hover:bg-muted"
                >
                  <span className="flex-1">{option.label}</span>
                  {isSelected && <Check className="size-4 text-primary" />}
                </button>
              );
            })}
          </MenuPopup>
        </MenuPositioner>
      </MenuPortal>
    </MenuRoot>
  );
}
